/**
 * Centralna definicija kategorija kolacica/tracking-a koji se prikazuju u
 * Cookie Consent baner-u (vanilla-cookieconsent v3) i koje konsumiraju ostali
 * delovi aplikacije (GA4 loader, Meta Pixel loader, Meta CAPI gate u
 * ScheduleStep5Page-u).
 *
 * Imena (key-evi) MORAJU biti identicna sa kategorijama definisanim u
 * consentManager.ts → CookieConsent.run({ categories: { ... } }).
 *
 * GDPR / ePrivacy:
 *   - NECESSARY je uvek aktivna (i ne moze da se iskljuci od strane korisnika);
 *     pokriva tehnicki neophodne kolacice (auth/session, jezik, Monri checkout).
 *   - ANALYTICS i MARKETING su opt-in (default OFF); skripte se ucitavaju TEK
 *     kada korisnik prihvati odgovarajucu kategoriju.
 */
export enum ConsentCategory {
    NECESSARY = 'necessary',
    ANALYTICS = 'analytics',
    MARKETING = 'marketing',
}
